export enum DatadogLocalStorageKeys {
  COOKIE_PREFERENCE_SET = 'CP_COOKIE_PREFERENCE_SET',
  COOKIES_ALLOWED = 'CP_COOKIES_ALLOWED',
  CURRENT_USER = 'currentUser'
}
